import Features from "./Features";
import Gymbevoegdheid from "./Gymbevoegdheid";
import Screen from "./Screen";
import Footer from "./Footer";

import { FunctiesProvider } from "./Context/FunctiesContext";

const Functies = ({ children }) => {
	return <FunctiesProvider>{children}</FunctiesProvider>;
};

Functies.Wrapper = ({ children }) => {
	return <div className="row functies">{children}</div>;
};

Functies.Features = () => {
	return (
		<div className="col-lg-6">
			<Features />
		</div>
	);
};

Functies.Gym = () => {
	return <Gymbevoegdheid />;
};

Functies.Screen = ({ children }) => {
	return <Screen>{children}</Screen>;
};

Functies.Footer = () => {
	return <Footer />;
};

export default Functies;
